<template>
	<div>
		<div v-if="loading" class="row">
			<LoadingSpinner class="col-12" />
		</div>
		<div v-else class="row">
			<div class="col-4">
				<div class="mb-4">
					<label class="col-form-label"><strong>{{ $t('monte.congelation.destinataire_manuel') }}</strong></label><br>
					{{ commande.semenceexpedition_destinataire_manuel }}<br>
					{{ commande.semenceexpedition_destinataire_manuel_firstname }} {{ commande.semenceexpedition_destinataire_manuel_lastname }}<br>
					{{ commande.semenceexpedition_destinataire_manuel_adress }}<br>
					{{ commande.semenceexpedition_destinataire_manuel_postalcode }} {{ commande.semenceexpedition_destinataire_manuel_town }} {{ destinataire_manuel_country }}<br>
					{{ commande.semenceexpedition_destinataire_manuel_mail }}<br>
					{{ commande.semenceexpedition_destinataire_manuel_tel }}
				</div>
				<div>
					<label class="col-form-label"><strong>{{ $t('monte.congelation.destinataire_selected') }}</strong></label><br>
					<template v-if="destinataire_selected && destinataire_selected.tiers_id">
						<span v-if="destinataire_selected.tiers_rs">{{ destinataire_selected.tiers_rs }}</span><br>
						<span v-if="destinataire_selected.tiers_address1">{{ destinataire_selected.tiers_address1 }}</span><br>
						<span v-if="destinataire_selected.tiers_postalcode">{{ destinataire_selected.tiers_postalcode }} </span><span v-if="destinataire_selected.tiers_town">{{ destinataire_selected.tiers_town }}</span> {{ destinataire_selected_country }}<br>
						<span v-if="destinataire_selected.tiers_mail">{{ destinataire_selected.tiers_mail }}<br></span>
						<span v-if="destinataire_selected.phone && destinataire_selected.phone.length > 0 && destinataire_selected.phone[0].phone_combine">{{ destinataire_selected.phone[0].phone_combine }}</span>
					</template>
				</div>
			</div>
			<div class="col-8">
				<div class="row">
					<div class="col-5">
						<label class="col-form-label">{{ $t('monte.congelation.destinataire') }} *</label>
						<SearchTiers
							v-if="reload_search_tiers"
							:tiers_selected.sync="form.destinataire"
							:preselected="form.destinataire"
							:with_tags="true"
						/>
						<div v-if="commandes_destinataire.length > 0" class="text-danger mt-2">
							<strong>{{ $t('monte.congelation.expeditions_same_destinataire') }}</strong><br>
							<span v-for="cmd in commandes_destinataire" :key="cmd.status">
								{{ $t('monte.congelation.status.'+cmd.status) }} : {{ cmd.nb }}<br>
							</span>
						</div>
					</div>
					<div class="col-1 pl-0 mt-3">
						<label>&nbsp;</label>
						<b-button variant="secondary" block @click="openAddTier"><font-awesome-icon :icon="['far', 'plus']" /></b-button>
					</div>
					<div class="col-6 mt-1">
						<label for="date">{{ $t("monte.congelation.date_expedition") }} *</label>
						<e-datepicker id="date" v-model="form.semenceexpedition_expedition_date" mode="date"></e-datepicker>
					</div>
					<div v-if="!commande.semenceexpedition_dose" class="col-6 mt-1 form-group">
						<label for="qte">{{ $t("monte.congelation.norme") }}</label>
						<e-select
							v-model="form.norme"
							id="protocole_id"
							track-by="protocole_id"
							label="protocole_label"
							:placeholder="$t('monte.congelation.selectionner_protocole')"
							:selectedLabel="$t('global.selected_label')"
							:options="protocoles"
							:searchable="true"
							:show-labels="false"
							:group-select="false"
						>
							<template slot="noOptions">{{ $t('global.list_empty') }}</template>
						</e-select>
						<span v-if="stock_available">{{ $t('monte.congelation.stock') }} : {{ stock_available.nb_stock }} - {{ $t('monte.congelation.stock_theorique') }} : {{ stock_available.nb_theorique }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="row mt-2">
			<div class="col-12 text-center">
				<b-button :disabled="stock_available && stock_available.nb_theorique <= 0" @click="save" variant="primary">{{ $t('action.valider') }} <font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" spin /><font-awesome-icon v-else :icon="['fal', 'check']" /></b-button>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue'
	import Congelation from "@/mixins/Congelation.js"
	import Shutter from '@/mixins/Shutter.js'
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"
    import Tiers from "@/mixins/Tiers.js"
    import Countries from '@/assets/lang/countries/countries'

	export default {
		name: 'ValidCommande',
		mixins: [Congelation, Shutter, ShutterCongelation, Tiers],
		props: ['commande'],
		data () {
			return {
				form: {
					norme: null,
					destinataire: null,
					semenceexpedition_expedition_date: new Date()
				},
				processing: false,
				reload_search_tiers: true,
				loading: false,
				protocoles: [],
				stock_available: null,
				destinataire_selected: null,
				commandes_destinataire: []
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.stock_available = null
				this.loading = true
				this.form.destinataire = {...this.commande.destinataire}
				if(!Object.prototype.hasOwnProperty.call(this.form.destinataire, 'tiers_id')) {
					this.form.destinataire.tiers_rs = ''
				}
				// Initialiser destinataire_selected
				this.destinataire_selected = this.form.destinataire
				
				// Charger les commandes du destinataire
				if(this.destinataire_selected && this.destinataire_selected.tiers_id) {
					this.checkCommandeDestinataire()
				}
				
				this.form.semenceexpedition_expedition_date = new Date(this.commande.semenceexpedition_expedition_date)
				this.protocoles = await this.getAllProtocoles()
				this.loading = false
			},

			async save() {
				if(!this.form.destinataire || !this.form.semenceexpedition_expedition_date || this.processing || (this.stock_available && this.stock_available.nb_theorique <= 0)) {
					return false
				}
				const protocole_id = this.form.norme ? this.form.norme.protocole_id : null
				this.processing = true
				await this.valideExpedition(this.commande.semenceexpedition_id, this.form.destinataire.tiers_id, this.form.semenceexpedition_expedition_date, protocole_id)
				this.processing = false
				this.successToast('toast.info_save_succes')
				this.ok()
				this.shutterPanel().close('valid-commande')
			},

			openAddTier() {
				this.setupAddTier(this.commande)
			},

			async reloadTiers(tiers_id) {
				this.shutterPanel().goTo('valid-commande')
				this.reload_search_tiers = false
				this.form.destinataire = await this.loadTier(tiers_id)
				this.reload_search_tiers = true
			},

			preselectProtocole() {
				if(this.form.destinataire && !this.form.norme) {
					const norme = this.protocoles.find(p => p.protocole_countries && p.protocole_countries.includes(this.form.destinataire.tiers_country))
					if(norme) {
						this.form.norme = norme
					}
				}
			},

			async loadStocks() {
				this.stock_available = null
				if(this.commande.demandeur) {
					const protocole = this.form.norme ? this.form.norme.protocole_id : ''
					this.stock_available = await this.getLotsAvailable(this.commande.stallion.horse_id, this.commande.demandeur.tiers_id, protocole, this.commande.semenceexpedition_id)
				}
			},

			async checkCommandeDestinataire() {
				this.commandes_destinataire = []
				if(this.form.destinataire && this.form.destinataire.tiers_id) {
					this.getCommandeDestinataire(this.form.destinataire.tiers_id, [1,2,3,4,5], this.commande.semenceexpedition_id).then(res => {
						this.commandes_destinataire = res
					})
				}
			}
		},

		computed: {
			destinataire_manuel_country() {
				return this.commande.semenceexpedition_destinataire_manuel_country ? Countries[Vue.i18n.locale()].label[this.commande.semenceexpedition_destinataire_manuel_country] : ''
			},
			destinataire_selected_country() {
				return this.destinataire_selected.tiers_country ? Countries[Vue.i18n.locale()].label[this.destinataire_selected.tiers_country] : ''
			}
		},

		watch: {
			'commande.semenceexpedition_id'() {
				this.init_component()
			},

			'form.norme'() {
				this.loadStocks()
			},

			'form.semenceexpedition_expedition_date'() {
				this.loadStocks()
			},

			'form.destinataire': {
				handler(val) {
					this.preselectProtocole()
					this.destinataire_selected = val
					this.checkCommandeDestinataire()
				},
				deep: true
			}
		},

		components: {
			SearchTiers : () => import('@/components/Contract/SearchTiers'),
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}

</script>